import { Components, Theme } from '@mui/material/styles'

export const MuiTextField: Components<Theme>['MuiTextField'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '&.otpInput': {
        '.MuiInputBase-root': {
          padding: '0',
          borderRadius: '0',
          // 16: below it iOS zooms the page on focus (see MuiInputBase).
          fontSize: 16,
          margin: 0,
          /*
           * 44, PINNED — deliberately not `FIELD_HEIGHT`.
           *
           * A one-time-code box is not a text field: it is 32px wide and sized to
           * a digit, and both call sites (`components/UI/OtpInput` and
           * `pages/SignIn/OtpVerify`) wrap it in a 32×44 Box whose height it has
           * to fill. It only ever measured 44 because it inherited the 44px floor
           * `MuiInputBase.ts` used to impose on every input in the app; when that
           * floor moved to FIELD_HEIGHT the boxes would have shrunk to 40 inside
           * their 44px wrappers. Stated here so the OTP grid owns its own metric
           * rather than depending on a global default that has now changed once.
           */
          height: '44px',
          minHeight: '44px',
          '.MuiInputBase-input': {
            textAlign: 'center',
            height: '44px',
          },
        },
        '&.error': {
          '.MuiInputBase-root': {
            border: `1px solid ${theme.palette.error.main}`,
          },
        },
      },
    }),
  },
}
